import { useState } from 'react'
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton
} from '@mui/material'
import { makeStyles } from "@mui/styles"
import Loading from './loading'
import AccountAdmins from '../components/account/admins'
import AccountSettings from '../components/account/settings'
import AccountImage from '../components/account/image'
import AccountUser from '../components/account/user'
import Navigation from '../components/navigation'
import {
  LogoutRounded
} from '@mui/icons-material'
import { useTheme, styles, stylesDark, Styles } from '../providers/theme'
import { useAuth } from '../providers/auth'
import { socket } from '..'

const useStylesLight = makeStyles<any, Styles>({...styles})
const useStylesDark = makeStyles<any, Styles>({...stylesDark})

export default function Account() {
  const [dialog, setDialog] = useState<boolean>(false)
  const [deleteAccountDialog, setDeleteAccountDialog] = useState<boolean>(false)
  const {user, loading, signOut} = useAuth()
  const {mode, setMode} = useTheme()
  const classesLight = useStylesLight(styles)
  const classesDark = useStylesDark(stylesDark)
  const classes = mode === 'light' ? classesLight : classesDark

  const title = 'Account'

  return (
    loading ?
      <Loading/>
    :
      <>
        <Navigation
          title={title}
          backTo
          actions={
            <>
              <IconButton 
                onClick={() => setDialog(true)}
                size="large"
                aria-label="logout user"
                aria-controls="logout-appbar"
                aria-haspopup="true"
                color="inherit"
                edge="end"
              >
                <LogoutRounded />
              </IconButton>
            </>
          }
        >
          <Container className={classes.accountCard}>
            <AccountImage />
            <AccountUser />
            <Divider
              style={{
                width: "80%",
                backgroundColor: "#888",
                border: "1px solid #888",
                borderRadius: "1px"
              }}
            />
            <AccountSettings />
            <AccountAdmins />
            <Button 
                variant="outlined"
                sx={{
                  marginTop: ".5em",
                  borderRadius: "10px",
                  color: "#f53636",
                  border: "1px solid #f53636",
                  "&:hover": {
                    border: "1px solid #f53636",
                    backgroundColor: "#f53636",
                    color: "white"
                  }
                }}

                onClick={async () => {
                  setDeleteAccountDialog(true)
                }}
              >
                Delete Account
              </Button>
          </Container>
        </Navigation>

        <Dialog
          open={dialog}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={() => setDialog(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Sign out?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to sign out?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialog(false)} color="secondary">Cancel</Button>
            <Button
              onClick={async () => {
                setMode('light')
                await signOut()
              }}
              autoFocus
              color="error"
            >
              Sign out
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={deleteAccountDialog}
          PaperProps={{
            style: {
              backgroundColor: mode === 'light' ? "#f6f6f6" : "#252525",
              borderRadius: "10px",
              boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
            }
          }}
          onClose={() => setDeleteAccountDialog(false)}
          fullWidth
          maxWidth="xs"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          
        >
          <DialogTitle id="alert-dialog-title">
            Delete Account
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete your account?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => setDeleteAccountDialog(false)}
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                socket.emit('delete_account', user!.uid)
              }}
              autoFocus
              color="error"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </>
  )
}
